import { useMutation } from "@tanstack/react-query";
import { OrdersService } from "@/services/orders/orders-service";
import { CsrfService } from "@/services/csrf/csrf-service";

interface PostCommentParams {
  taxonomyId: string;
  message: string;
}

const ordersService = new OrdersService();
const csrfService = new CsrfService();

export const usePostComment = () => {
  return useMutation({
    mutationFn: async ({ taxonomyId, message }: PostCommentParams) => {
      const csrfToken = await csrfService.getToken();
      return ordersService.postComment({
        taxonomyId,
        message,
        csrfToken,
        tags: ["hw-order-support", "amazonian"],
      });
    },
  });
};
